import _ from 'lodash';
import React,{useState,useEffect} from 'react';
import CNGLayerIcon from "../../assets/cng-svg.png"
import Table from 'react-bootstrap/Table';
import '../SideBar/SideBar.css';
import {POI_Census_Count_url, RDSE_COUNT} from '../../Essentials/variables';
export const poiIcons = new Map([['HOSPITALS', 'fa-solid fa-house-medical'],
                                ['SCHOOLS', 'fa-solid fa-school'],
                                ['AGRI_MANDIS', 'fa-solid fa-building-wheat'],
                                ['BANKS', 'bi bi-bank2'],
                                ['INDUSTRIAL_CENTER', 'bi bi-hammer'],
                                ['PETROL_PUMPS', 'bi bi-fuel-pump'],
                                ['CNG_PUMP_S', 'bi bi-device-ssd']]);

const poiCensusIcons = new Map([['Primary_School', 'fa-solid fa-school'],
['Secondary_School', 'fa-solid fa-school'],
['Hospital/PHC/CHC', 'fa-solid fa-house-medical']]);


function POITable(props){
    const [value,setValue] = useState(undefined);
    const [name,setName] = useState('');
    const [type,setType] = useState('');
    const [istehsil,setIstehsil]=useState(false);
    const [rsecount,setRsecount]=useState(0);
    const [rtlcount,setRtlcount]=useState(0);
    const [rrmcount,setRrmcount]=useState(0);
    const [village_count,setVillagecount]=useState('');
    const [population_count,setPopulationcount]=useState('');
    const [censusData,setCensusData] = useState({'Primary_School':'','Secondary_School':'','Hospital/PHC/CHC':''});
    const borderInfoName = [{
        'type' : 'State',
        'name' : 'STATE_NAME'
    },
    {
        'type' : 'District',
        'name' : 'DIST_NAME'
    },
    {
        'type' : 'SubDistrict',
        'name' : 'SUBDIST_NAME'
    },
    {
        'type' : 'Village',
        'name'  : 'VIL_NAME'
    }
]

function cencustablecomponent(f){
    //console.log(f.getProperties());
    let o = f?.getProperties();
    if(!_.isUndefined(o)){
        //console.log(o);
    let keys = Object.keys(o).filter((k)=>{
        if(['STATE_NAME','DIST_NAME','SUBDIST_NAME','VIL_NAME'].includes(k) && !_.isNull(o[k])){
            return k;
        }
    })
    let url = POI_Census_Count_url;
    let rdseurl=RDSE_COUNT;
    // console.log(keys.includes);
    keys.forEach(k => {
        url = url + '/' + _.replace(o[k],' District','');
        // rdseurl = rdseurl + '/' + _.replace(o[k],' District','');
        
    });
        
    keys.forEach(k => {
        setRrmcount(0);
        setRsecount(0);
        setRtlcount(0);
        rdseurl = rdseurl + '/' + _.replace(o[k],' District','');
        if(k==='SUBDIST_NAME'){  fetch(rdseurl,{
            headers: {
                'x-access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Frame-Options': 'DENY',
                        'Content-Security-Policy': "frame-ancestors 'none'",
                        'Feature-Policy': "frame-ancestors 'none'"
              },
        }).then((r)=>r.json()).then((data)=>{
            // console.log(data);
            data?.map((subdata)=>{
               console.log(subdata?.emp_desg_cd," ",subdata?.desg_count);
               if(subdata?.emp_desg_cd==='RSE')setRsecount(parseInt(subdata?.desg_count));
               if(subdata?.emp_desg_cd==='RTL')setRtlcount(parseInt(subdata?.desg_count));
               if(subdata?.emp_desg_cd==='RRM')setRrmcount(parseInt(subdata?.desg_count));
            })
            
        })
        .catch((err)=>{console.log(err)}) 
    }
        if(keys?.length===3){
            setIstehsil(true);
        }else{
            setIstehsil(false);
        }
        // console.log(keys.length);
        // else if(k==='VIL_NAME'){ setIstehsil(false) }
        // rdseurl = rdseurl + '/' + _.replace(o[k],' District','');
        
    });

    fetch(url,{
        
        headers: {
            'x-access-token': localStorage.getItem('token'),
            'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Frame-Options': 'DENY',
                        'Content-Security-Policy': "frame-ancestors 'none'",
                        'Feature-Policy': "frame-ancestors 'none'"
          },
    }).then((r)=>r.json()).then((data)=>{
        setVillagecount(data?.Location)
        setPopulationcount(data?.Population)
        delete data['Location'];
        setCensusData({...censusData,...data});
    })
    .catch((err)=>{console.log(err)});
    // fetch(rdseurl).then((r)=>r.json()).then((data)=>{
    //     console.log(data);
    // })
    //console.log(_.filter(f?.getProperties(),['STATE_NAME','DIST_NAME','SUBDIST_NAME','VIL_NAME']));
} 
}
// useEffect(()=>{
//     Token=localStorage.getItem('token')
// },[])
useEffect(()=>{cencustablecomponent(props.f);},[props.f]);
    useEffect(()=>{
        ////console.log('active');
        // setIstehsil(false)
        if(props.f?.values_){
            setValue(props.f?.values_);
            
            ////console.log(props.f?.values_);
            let blk = _.first(_.filter(borderInfoName,(ele) => ele.type ===  value?.TYPE));
            if(!_.isUndefined(value)){
                setName(value[blk.name]);
                setType(blk.type);
            }
        }       
    });


    let poitablecomponent = props?.POI?.map((key)=>{
        
        return (!['HOSPITALS','SCHOOLS'].includes(key) && (<tr key={key}>
                {/* <i className={poiIcons.get(key)} style={{'fontSize':'15px'}}></i> */}
                {poiIcons.has(key) && <td style={{'fontSize':'15px'}}><i className={poiIcons.get(key)} style={{'fontSize':'15px'}}></i></td>}
                {!poiIcons.has(key) && <td style={{'fontSize':'15px'}}><img src='cng-svg.png' style={{'width':'15px','height':'15px'}}/></td>}
                <td style={{'fontSize':'10px'}}>{key}</td>
                <td style={{'fontSize':'13px'}}>{!_.isUndefined(value) ? value[key] : 'Loading...'}</td>
        </tr>))
    });

    

    return(
    <div>
    <h6>{name} ({type})</h6>
    <p className=' text-xs'>VILLAGE COUNT : {new Intl.NumberFormat("en-IN").format(village_count)}</p>
    <p className=' text-xs'>POPULATION : {new Intl.NumberFormat("en-IN").format(population_count)}</p>
    {istehsil && <p className='font-medium text-xs'>RDSE : {rsecount} , RTL : {rtlcount} , RRM : {rrmcount}</p>}
    {/* <h6>Type : {type}</h6> */}
    <Table size='sm'>
        <thead>
            <tr>
                <i></i>
                <th style={{'fontSize':'15px'}}>POI</th>
                <th style={{'fontSize':'15px'}}>Count</th>
            </tr>
        </thead>
        <tbody>
        {Object.entries(censusData).map(([key,value])=>{
            //console.log(value);
            return( !['Population'].includes(key) &&
                <tr key={key}>
                  <i className={poiCensusIcons.get(key)} style={{'fontSize':'15px'}}></i>
                  <td style={{'fontSize':'10px'}}>{_.replace(key.toUpperCase(),'_',' ')}</td>
                  <td style={{'fontSize':'13px'}}>{value !== '' && value !== undefined ? value : 'Loading...'}</td>
               </tr>
            );
        })}
            {poitablecomponent}
            {/* {istehsil && RRMPOI}
            {istehsil && RSEPOI}
            {istehsil && RTLPOI} */}
        </tbody>
    </Table>
    </div>
    );

}

export default POITable;
